import {InitBurger} from './components/burger_menu.js'
// import {InitSelects} from './components/custom_select.js'


document.addEventListener('DOMContentLoaded', function () {
    console.log("ready")
    InitBurger()
    // InitSelects()
})